import { Pipe, PipeTransform } from '@angular/core';
import { UserDetailsService } from 'ZalamoLibrary/src/lib/zalamo/auth/user-details.service';

@Pipe({
    name: 'isMe',
    standalone: false
})
export class IsMePipe implements PipeTransform {
  constructor(private userDetailsService: UserDetailsService) {}

  transform(authorId: string): boolean {
    return String(authorId) === String(this.userDetailsService.getUserId());
  }
}
